module.exports = __webpack_public_path__ + "static/img/portrait-female-white.e6c2bd66.png";